import { Component, ViewChild, inject } from '@angular/core';
import { CommonModule, Location, NgOptimizedImage } from '@angular/common';
import OmniSearchComponent from '../../components/omni-search/omni-search.component';
import {RouterLink} from '@angular/router';
import {SvgIconComponent} from '@ngneat/svg-icon';
import {UserService} from '../../services/user.service';
import {User} from '../../models/user';
import {LayoutClassDirective} from '../../services/directives/layout-class.directive';
import {DialogComponent} from '../../components/modal-dialog/dialog.component';
import {EventService, MenuState} from '../../services/event.service';

@Component({
    selector: 'app-header',
    imports: [CommonModule, OmniSearchComponent, RouterLink, SvgIconComponent, NgOptimizedImage, DialogComponent],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    host: { 'class': 'content-gutter' },
    hostDirectives: [LayoutClassDirective]
})
export class HeaderComponent {
	private location = inject(Location);
	private userService = inject(UserService);
	private eventService = inject(EventService);

	@ViewChild('logoutDialog') logoutDialog?: DialogComponent;
	user?: User;

	// todo Shawn (author) to document
	currentLocation?: string;

	login = () => this.userService.login(this.currentLocation);

	logout = () => this.userService.logout();

	constructor() {
		this.userService.user.subscribe(x =>
			this.user = x
		);
		this.location.onUrlChange(url => this.currentLocation = url);
	}

	openMenu() {
		this.eventService.setMenu(MenuState.open);
	}

}
